<template>
  <drawer @close="drawerCloseEvent()" width="680">
    <transition name="slide">
      <component
        :is="component"
        :group="group"
        :groupModel="groupModel"
        :details="details"
        v-model="request[currentModel]"
        :request="request"
        :sendingEmail="sendingEmail"
        @next="next()"
        @paymentType="setPaymentType"
      />
    </transition>
    <template v-slot:append>
      <div
        class="px-5 px-md-24 py-6 d-flex flex-column flex-md-row justify-lg-space-between"
      >
        <v-btn
          min-width="45%"
          large
          class="white mb-3 mb-md-0 px-14"
          @click="back()"
          :disabled="groupModel.fetching || sendingEmail"
        >
          {{ step === 1 ? 'Cancel' : 'Back' }}
        </v-btn>
        <v-btn
          v-if="groupModel.fetched"
          :disabled="
            groupModel.fetching || sendingEmail || !request.project_id || loader
          "
          min-width="45%"
          large
          class="primary px-14"
          @click="next()"
          :loading="loader"
        >
          {{ buttonText() }}
        </v-btn>
      </div>
    </template>
  </drawer>
</template>

<script>
import GroupModel from '@models/Group';
import Group from '@models/Group';

export default {
  name: 'Checkout',
  components: {
    Drawer: () => import('@layouts/_partials/Drawer'),
    CheckoutDetails: () => import('./_partials/CheckoutDetails'),
    Payment: () => import('./_partials/Payment'),
    Authentication: () => import('./_partials/Authentication'),
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      details: {},
      groupModel: new GroupModel(),
      step: 1,
      sendingEmail: false,
      preventClose: false,
      request: {
        currency_code: 'USD',
        verification_code: '',
        amount: 0,
        project_id: 0,
      },
      loader: false,
      paymentType: 'cash',
    };
  },
  computed: {
    component() {
      if (this.step === 3 && !this.isTourist) {
        return 'Authentication';
      } else if (this.step === 2) {
        return 'Payment';
      } else {
        return 'CheckoutDetails';
      }
    },
    currentModel() {
      if (this.step === 1) {
        return 'project_id';
      }
      if (this.step === 3) {
        return 'verification_code';
      }

      return '';
    },
    isTourist() {
      return this.currentUser.isTourist();
    },
    isCash() {
      return this.paymentType === 'cash';
    },
  },
  methods: {
    setPaymentType(data) {
      this.paymentType = data;
    },
    async fetchCheckoutDetails() {
      if (!this.group.sightings_reported) {
        return;
      }
      let response = await this.groupModel.fetchCheckoutDetails(this.group.id);
      if (response) {
        this.details = response.data;
        this.request.amount = response.data.amount;
        this.request.project_id = response.data.project_id || '';
      }
    },
    cancel() {
      this.$parent._data.drawerView = '';
      this.$parent._data.jumpStep = 1;
    },
    back() {
      this.step === 1 && this.cancel();
      this.step > 1 && this.step--;
    },
    paymentCompleted() {
      this.loader = false;
      this.$emit('refresh');
      this.cancel();
    },
    async authenticate() {
      this.sendingEmail = true;
      let response = await this.groupModel.sendAuthenticationCode(
        this.group.id
      );
      if (response) {
        $showInfo(
          "A confirmation email has been sent to group leader's email!",
          'checkout-toast'
        );
      }

      this.sendingEmail = false;
      return response;
    },
    async checkout() {
      let response = await this.groupModel.checkout(
        this.group.id,
        this.request
      );
      if (response) {
        this.$emit('refresh');
        this.cancel();
      }
    },
    async drawerCloseEvent() {
      if (
        !this.preventCheckout ||
        (await $question("You haven't checked out. Are you sure?"))
      ) {
        this.cancel();
      }
    },
    async next() {
      if (this.step === 2 && this.isCash) {
        if (await this.authenticate()) {
          this.step++;
        }
      } else if (this.step === 3 && this.isCash) {
        await this.checkout();
      } else if (this.step === 2 && !this.isCash) {
        if (this.paymentType === 'stripe-invoice') {
          this.loader = true;
          return await this.sendInvoice();
        }
        this.loader = true;
        this.$bus.$emit('pay', this.group.id, this.request);
      } else {
        this.preventCheckout = true;
        this.isTourist
          ? this.step < 2 && this.step++
          : this.step < 3 && this.step++;
      }
    },

    async sendInvoice() {
      const self = this;
      const model = new Group();
      const response = await model
        .sendStripeInvoice(this.group.id, this.request)
        .finally(() => {
          self.loader = false;
        });

      if (!response) {
        return;
      }

      this.$emit('refresh');
      this.cancel();
    },
    buttonText() {
      if (this.step === 1) {
        return 'Proceed';
      } else if (this.step === 2 && !this.isCash) {
        return 'Pay';
      } else {
        return 'Confirm';
      }
    },
  },
  mounted() {
    const self = this;
    this.fetchCheckoutDetails();
    this.$bus.$on('payment_completed', (res) => {
      self.loader = false;
      if (res) self.paymentCompleted();
    });
  },
};
</script>
